<template>
	<c-dialog ref="dialog" width="900" mode="slide"  enable-flex mask-close >
		<!--顶部商品信息条：产品名 + 背贴码 | 所属商户（通栏贴边，弹框内容区无自带内边距，宽度 100% 即贴边）-->
		<div class="m-product-bar">
			<p class="m-product-name">{{oversold.product_name || '-'}}</p>
			<p class="m-product-sub">背贴码：{{oversold.produce_code || '-'}}　|　{{oversold.saas_name || '-'}}</p>
		</div>

		<!--取消订单弹框（嵌套在主 slide 抽屉内，popup 模式叠加显示）：填写取消原因后提交，后端强制必填且写入业务日志-->
		<c-dialog ref="cancelDialog" title="取消该订单" width="480">
			<div class="m-cancel-body">
				<p class="m-cancel-tip">确认取消订单【{{cancelingCard.order_no || ''}}】吗？取消后本机占用释放，超卖单将在重估后自动更新。</p>
				<p class="m-cancel-label">取消原因（必填）</p>
				<c-input v-model="cancelRemark" type="textarea" maxlength="500" :height-resize="{minHeight: '80px'}" placeholder="请填写取消原因，供后续核对"></c-input>
			</div>
			<template #button>
				<c-button size="dialog" color="red" :disabled="isCancelling" @click="submitCancel">确认取消</c-button>
				<c-button size="dialog" :disabled="isCancelling" @click="$refs.cancelDialog.close()">再想想</c-button>
			</template>
		</c-dialog>

		<div class="m-content">
			<!--占用订单卡片列表：勾选其中一单保留-->
			<c-title>选择最终销售渠道</c-title>

			<div
				v-for="card in channelCards"
				:key="card.sold_flag == 1 ? 'sold_' + card.confirm_lock_id : card.order_id"
				class="m-channel-card"
				:class="{'m-selected': card.sold_flag != 1 && confirmOrderId == card.order_id, 'm-sold-card': card.sold_flag == 1}"
			 	>
				<div class="m-card-head flex-center-cross" @click="selectCard(card)">
					<!--勾选框：单选，只能勾一单保留；售出那一路不可勾选-->
					<c-checkbox readonly :disabled="card.sold_flag == 1" :value="confirmOrderId == card.order_id">
						<span class="m-channel-name">{{card.channel_name || '-'}}</span>
					</c-checkbox>
					<c-state v-if="card.sold_flag != 1" tag async dict="SALES_ORDER_STATE" :value="card.order_state"></c-state>
					<span v-if="card.sold_flag == 1" class="m-sold-tag">已售出</span>
					<span v-if="card.sold_flag != 1" class="m-card-prices flex">
						<span v-if="card.offline_flag != 1">结算价：<b>{{formatPrice(card.expect_settle_amount)}}</b>　</span>
						<span>售出价：<b class="m-sale-price">{{formatPrice(card.sale_price)}}</b></span>
					</span>
				</div>
				<div class="m-card-body">
					<!--售出终态这一路：不是可处理的在途订单，仅说明超卖占用数里多出来那一路在哪里-->
					<template v-if="card.sold_flag == 1">
						<p><label>成交单号：</label>{{card.order_no || '无（锁凭证售出，未回写订单）'}}</p>
						<p><label>成交价：</label><span class="m-amount">{{formatPrice(card.sale_price)}}</span></p>
						<p><label>售出时间：</label>{{card.sold_date || '-'}}</p>
					</template>
					<!--线下开单这一路：无三方单号/收货人/结算信息，展示客户与开单时间，可作为保留对象-->
					<template v-else-if="card.offline_flag == 1">
						<p><label>订单号：</label>{{card.order_no || '-'}}</p>
						<p><label>客户：</label>{{card.customer_name || '-'}}</p>
						<p><label>下单时间：</label>{{card.create_date || '-'}}</p>
					</template>
					<template v-else>
						<p><label>订单号：</label>{{card.order_no || '-'}}</p>
						<p><label>收货人：</label>{{card.receiver_name || '-'}}（{{card.receiver_phone || '-'}}）</p>
						<p><label>收货地址：</label>{{card.receiver_address || '-'}}</p>
						<p><label>下单时间：</label>{{card.create_date || '-'}}</p>
					</template>
					<!--逐单取消：需有取消权限码，且仅对可取消、未被选为保留的在途单显示（售出卡无此入口）-->
					<p v-if="canCancel(card) && auth('b_ops_oversold_cancel')" class="m-cancel-row">
						<c-button color="red" hollow @click="cancelOrder(card)">取消该订单</c-button>
					</p>
				</div>
			</div>

			<!--备注（运营填写的处理说明，保存到超卖单上并在详情中回显）-->
			<div class="m-remark-wrap">
				<p class="m-remark-label">备注（必填）</p>
				<!--组件库 textarea 不认 rows 属性，行数用 height-resize 控制（同 quality_report_edit 的用法），90px 约三行-->
				<c-input v-model="handleRemark" type="textarea" maxlength="500" :height-resize="{minHeight: '90px'}" placeholder="请填写处理备注"></c-input>
			</div>
		</div>

		<template #button>
			<c-button color="main" size="dialog" @click="submitHandle">确认提交</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'oversoldHandle',

		data() {
			return {
				oversoldId: '',
				oversold: {},
				channelCards: [],
				confirmOrderId: '',
				handleRemark: '',
				cancelingCard: {},
				cancelRemark: '',
				isCancelling: false
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data = {}) {
				this.oversoldId = data.oversoldId;
				this.oversold = {};
				this.channelCards = [];
				this.confirmOrderId = '';
				this.handleRemark = '';
				this.$refs.dialog.open({title: '超卖订单处理'});
				this.loadDetail();
			},

			/*********加载超卖详情（运营端接口，服务端先查这条超卖单属于哪个商户再组装返回）**********/
			loadDetail() {
				this.request({
					url: '/ops/oversold/sale/order/detail',
					data: {
						id: this.oversoldId
					},
					loading: true,
					success: data => {
						this.oversold = data.oversold || {};
						this.channelCards = data.channel_cards || [];
					}
				});
			},

			/*********勾选保留订单（售出终态卡不可选，线上单与线下开单单均可选）**********/
			selectCard(card) {
				if (card.sold_flag == 1) return;
				this.confirmOrderId = card.order_id;
			},

			/*********能否取消该占用订单：线上单待收款或待发货可取消，线下单只有待收款可取消；已售出的和已勾选保留的不能取消**********/
			canCancel(card) {
				if (card.sold_flag == 1) return false;
				if (this.confirmOrderId && this.confirmOrderId == card.order_id) return false;
				if (card.offline_flag == 1) return card.order_state == 1;
				return card.order_state == 1 || card.order_state == 2;
			},

			/*********取消该占用订单：打开取消弹框让运营填写原因，后端强制必填并写业务日志**********/
			cancelOrder(card) {
				var merchant_id = this.oversold.saas_id;
				if (!merchant_id) {
					this.$message({message: '商户信息未加载，请刷新后重试', type: 'warn'});
					return;
				}
				this.cancelingCard = card;
				this.cancelRemark = '';
				this.$refs.cancelDialog.open();
			},
			/*********提交取消订单：带运营填写的原因调统一取消接口，成功后重载详情**********/
			submitCancel() {
				if (this.isCancelling) return;
				var remark = this.cancelRemark.trim();
				if (!remark) {
					this.$message({message: '请填写取消原因', type: 'warn'});
					return;
				}
				if (remark.length > 500) {
					this.$message({message: '取消原因不能超过500字', type: 'warn'});
					return;
				}
				var card = this.cancelingCard;
				if (card.order_id == this.confirmOrderId) this.confirmOrderId = '';
				this.isCancelling = true;
				this.request({
					url: '/sale/order/ops/cancel',
					data: {
						merchant_id: this.oversold.saas_id,
						order_id: card.order_id,
						cancel_source: 'oversold',
						remark: remark
					},
					loading: true,
					success: (data, msg) => {
						this.$refs.cancelDialog.close();
						this.$message({message: msg || '取消成功', type: 'success'});
						this.loadDetail();
					},
					complete: () => {
						this.isCancelling = false;
					}
				});
			},

			/*********格式化价格：整数不带小数位，与设计图展示一致**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				var num = parseFloat(price);
				return '¥ ' + (num % 1 === 0 ? num : num.toFixed(2));
			},

			/*********确认提交（选中的订单保留，其余订单由运营另行通知商户处理）**********/
			submitHandle() {
				if (!this.confirmOrderId) {
					this.$message({message: '请选择要保留的订单', type: 'warn'});
					return;
				}
				var remark = (this.handleRemark || '').trim();
				if (!remark) {
					this.$message({message: '请填写处理备注', type: 'warn'});
					return;
				}
				if (remark.length > 500) {
					this.$message({message: '备注内容不能超过500字', type: 'warn'});
					return;
				}
				this.request({
					url: '/ops/oversold/sale/order/handle',
					data: {
						id: this.oversoldId,
						confirm_order_id: this.confirmOrderId,
						handle_remark: remark
					},
					loading: true,
					success: (data, msg) => {
						this.$message({message: msg || '处理成功', type: 'success'});
						this.$refs.dialog.close();
						this.$emit('resolve');
					}
				});
			},

			/*********关闭弹框**********/
			closeDialog() {
				this.$refs.dialog.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-bar {
		margin-bottom: 20px;
		padding: 14px 20px;
		background: #eef3fe;
		text-align: center;

		.m-product-name {
			font-size: 17px;
			font-weight: bold;
			color: #3d6ced;
		}

		.m-product-sub {
			margin-top: 6px;
			font-size: 13px;
			color: #666;
		}
	}

	/*内容区左右留白：弹框内容区本身无内边距，这里统一控制，蓝色头栏不受影响保持通栏*/
	.m-content {
		padding: 0 24px 4px;
	}

	.m-section-title {
		display: flex;
		align-items: center;
		margin-bottom: 16px;
		font-size: 15px;
		font-weight: bold;
		color: #333;

		.m-section-icon {
			width: 16px;
			height: 16px;
			margin-right: 6px;
		}
	}

	.m-channel-card {
		margin-bottom: 20px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		transition: border-color .2s, box-shadow .2s;

		&.m-selected {
			border-color: #3d6ced;
		}

		/*售出终态卡：仅做说明不可操作，置灰虚线边与可处理卡片区分*/
		&.m-sold-card {
			background: #fbfbfb;
			border-style: dashed;
			border-color: #d9d9d9;
		}

		.m-card-head {
			gap: 10px;
			padding: 12px 20px;
			background: #fafafa;
			border-bottom: 1px solid #f0f0f0;
			cursor: pointer;

			/*勾选框：正方形空框，勾选后蓝底白勾*/
			.m-check {
				width: 18px;
				height: 18px;
				line-height: 18px;
				flex-shrink: 0;
				border: 1px solid #c0c4cc;
				border-radius: 3px;
				background: #fff;
				font-size: 13px;
				text-align: center;
				color: transparent;

				&.m-checked {
					border-color: #3d6ced;
					background: #3d6ced;
					color: #fff;
				}
			}

			.m-channel-name {
				font-size: 15px;
				font-weight: bold;
				color: #333;
			}

			.m-card-prices {
				gap: 15px;
				margin-left: auto;
				font-size: 13px;
				color: #666;
				white-space: nowrap;

				b {
					font-size: 14px;
					color: #333;
				}

				.m-sale-price {
					font-size: 16px;
					color: #f5222d;
				}
			}

			.m-sold-tag {
				padding: 0 6px;
				font-size: 12px;
				line-height: 20px;
				border-radius: 2px;
				color: #8c8e91;
				background: #f0f0f0;
			}
		}

		.m-card-body {
			padding: 10px 20px;
			line-height: 36px;
			font-size: 14px;
			color: #333;

			label {
				display: inline-block;
				width: 76px;
				color: #999;
			}

			.m-amount {
				font-weight: bold;
				color: #e53e3e;
			}

			.m-sold-desc {
				line-height: 22px;
				color: #fa8c16;
			}
		}
	}

	/*取消订单弹框内容区：嵌套 c-dialog 内容区默认无内边距，手动加 padding*/
	.m-cancel-body {
		padding: 16px 20px;

		.m-cancel-tip {
			margin-bottom: 14px;
			line-height: 22px;
			font-size: 13px;
			color: #666;
		}

		.m-cancel-label {
			margin-bottom: 8px;
			font-size: 13px;
			font-weight: bold;
			color: #333;
		}
	}

	/*逐单取消入口：卡片底部右对齐的红字链接*/
	.m-cancel-row {
		margin-top: 6px;
		padding-top: 8px;
		border-top: 1px dashed #f0f0f0;
		text-align: right;
		line-height: 20px;

		.m-cancel-link {
			font-size: 13px;
			color: #f5222d;
			cursor: pointer;
		}
	}

	.m-remark-wrap {
		margin: 20px 0 4px;

		.m-remark-label {
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;
		}

		/*穿透组件库默认字号，备注输入文字与卡片正文同档*/
		>>> textarea {
			font-size: 14px;
		}
	}
</style>
